import React, { useContext } from "react";
import styled from "styled-components";
import Flex from "../../../components/Box/Flex";
import { MenuContext } from "../context";

interface Props {
  href: string;
}

const StyledLink = styled("a")`
  display: flex;
  align-items: center;
  /* the 150 px wordmark from 1200 px (xxl; 968 until the Competitions tab joined the top bar on 2026-10-06, then 1080 until the
     prices came back next to the tabs on 2026-10-07), the mark below */
  .mobile-icon {
    width: 32px;
    height: 32px;
    ${({ theme }) => theme.mediaQueries.xxl} {
      display: none;
    }
  }
  .desktop-icon {
    width: 150px;
    height: auto;
    display: none;
    ${({ theme }) => theme.mediaQueries.xxl} {
      display: block;
    }
  }
  /* the wordmark is snow-on-transparent and used as provided (never recoloured);
     in the light theme it sits on a small night plate so it stays legible */
  ${({ theme }) =>
    !theme.isDark &&
    `
    .desktop-icon, .mobile-icon {
      background: #050713;
      border-radius: 10px;
      padding: 6px 10px;
      box-sizing: content-box;
    }
    .mobile-icon { padding: 2px; width: 28px; height: 28px; }
  `}
`;

/**
 * CADINU wordmark (snow letters, the D carrying the ink→violet gradient) — the approved header
 * treatment from cadinu.io. Used as provided, never recoloured; below 120px only the D shows.
 * Provenance: apps/web/public/images/brand/PROVENANCE.md
 */
const Logo: React.FC<React.PropsWithChildren<Props>> = ({ href }) => {
  const { linkComponent } = useContext(MenuContext);
  const isAbsoluteUrl = href.startsWith("http");
  const innerLogo = (
    <>
      <img className="desktop-icon" src="/images/brand/wordmark-lit-d.webp" alt="CADINU" width={150} height={28} />
      <img className="mobile-icon" src="/images/brand/mark-d.svg" alt="CADINU" width={32} height={32} />
    </>
  );

  return (
    <Flex alignItems="center">
      {isAbsoluteUrl ? (
        <StyledLink as="a" href={href} aria-label="CADINU home page">
          {innerLogo}
        </StyledLink>
      ) : (
        <StyledLink href={href} as={linkComponent} aria-label="CADINU home page">
          {innerLogo}
        </StyledLink>
      )}
    </Flex>
  );
};

export default React.memo(Logo);
